webpackJsonp([137000154566142],{

/***/ 323:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose([''], ['']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  padding: 2rem 0 0;\n'], ['\n  padding: 2rem 0 0;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  vertical-align: top;\n  margin: 0 0 4rem;\n  > li {\n    width: 100px;\n    margin: 0 10px 50px 10px;\n    padding: 10px;\n    list-style-type: none;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    \n    > a {\n      display: block;\n      padding: 1rem;\n      border: 1px solid black;\n    }\n  }\n'], ['\n  vertical-align: top;\n  margin: 0 0 4rem;\n  > li {\n    width: 100px;\n    margin: 0 10px 50px 10px;\n    padding: 10px;\n    list-style-type: none;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    \n    > a {\n      display: block;\n      padding: 1rem;\n      border: 1px solid black;\n    }\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  padding: 2rem 1rem;\n  margin: 5rem 0 4rem 0;\n  position: relative;\n'], ['\n  padding: 2rem 1rem;\n  margin: 5rem 0 4rem 0;\n  position: relative;\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  display: block;\n  width: 100px;\n  font-size: 2rem;\n  line-height: 2rem;\n  padding: 1rem;\n  top: -5rem;\n  left: 0;\n  border-bottom: 1px solid black;\n\n  > a {\n    color: black;\n  }\n'], ['\n  position: absolute;\n  display: block;\n  width: 100px;\n  font-size: 2rem;\n  line-height: 2rem;\n  padding: 1rem;\n  top: -5rem;\n  left: 0;\n  border-bottom: 1px solid black;\n\n  > a {\n    color: black;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(33);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _lodash = __webpack_require__(10);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _utils = __webpack_require__(18);
	
	var _styleUtils = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	// Utils
	
	
	var PageWrapper = _styledComponents2.default.section(_templateObject);
	
	var NutrientsWrapper = _styledComponents2.default.section(_templateObject2);
	
	var NutrientsList = _styledComponents2.default.ul(_templateObject3);
	
	var HeaderSection = _styledComponents2.default.section(_templateObject4);
	
	var BackLinkWrap = _styledComponents2.default.div(_templateObject5);
	
	var AllNutrientsPage = function AllNutrientsPage(_ref) {
	  var data = _ref.data;
	
	
	  var filteredNodes = _lodash2.default.sortBy(data.allMarkdownRemark.edges.filter(function (_ref2) {
	    var node = _ref2.node;
	    return node.frontmatter.type === 'nutrient';
	  }).map(function (_ref3) {
	    var node = _ref3.node;
	    return node;
	  }), function (node) {
	    return node.frontmatter.name;
	  });
	
	  return _react2.default.createElement(
	    PageWrapper,
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Nutrients & Vitamins'
	      )
	    ),
	    _react2.default.createElement(
	      HeaderSection,
	      null,
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Nutrients & Vitamins'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Find out what these things do to keep you healthy, and which foods you can find them in.'
	      ),
	      _react2.default.createElement(
	        BackLinkWrap,
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/' },
	          '\u2190 Home'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      NutrientsWrapper,
	      null,
	      _react2.default.createElement(
	        NutrientsList,
	        null,
	        filteredNodes.map(function (node) {
	          return _react2.default.createElement(
	            'li',
	            { key: node.frontmatter.name },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: node.frontmatter.path },
	              node.frontmatter.name
	            )
	          );
	        })
	      )
	    )
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = AllNutrientsPage;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-nutrients-js-cdf003dabb8988e84ee3.js